export const RECOMMENDATION_LABELS = {
  ACKNOWLEDGE: "Acknowledge",
  ACTION_ITEM: "Action item for you",
  COACHING: "Coaching",
  REVIEW: "Review",
};

export const COACHING_MEETING_NAME = "Coaching";
